<template>
  <NuxtLayout :name="layoutName" :navbar-color="layoutNavbarColor" :footer-color="layoutFooterColor">
    <section v-if="story && articles" class="press-releases">
      <main class="container">
        <BaseBreadcrumbs class="press-releases__breadcrumbs" />
        <h1 class="press-releases__heading heading--2">
          All Press releases {{ `(${articles.headers.total})` }}
        </h1>
        <NewsroomArticleEntry
          v-for="article in articles.data.stories"
          :key="article.uuid"
          class="press-releases__article-entry"
          :story="article"
        />
      </main>
    </section>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const { story } = await useFetchStory('newsroom/press-releases')
const { layoutName, layoutNavbarColor, layoutFooterColor } = useLayout<any>(story)

const config = useRuntimeConfig()
const storyblokApi = useStoryblokApi()

const [{ data: articles }] = await Promise.all([
  useAsyncData(
    'newsroom-articles',
    async () =>
      await storyblokApi.get('cdn/stories', {
        version: config.public.storyblokApiVersion as 'draft' | 'published',
        starts_with: 'newsroom/press-releases',
        per_page: 100,
        filter_query: {
          component: {
            in: 'newsroom-article',
          },
        },
      }),
  ),
])

useCustomHead(story)
false && /*#__PURE__*/ defineI18nRoute({
  locales: ['en'],
})
</script>

<style lang="scss" scoped>
.press-releases {
  padding: 32px 0 64px;

  @media (min-width: $breakpoint-lg) {
    padding: 32px 0 128px;
  }

  &__breadcrumbs {
    margin-bottom: 48px;
    text-transform: none !important;
  }

  &__heading {
    margin-bottom: 40px;

    @media (min-width: $breakpoint-lg) {
      margin-bottom: 64px;
    }
  }
}
</style>
